import type { FaireProductEntity } from "../../entity_types/product";

export const p_3txckf32rg: FaireProductEntity = {
  token: "p_3txckf32rg",
  type: "product",
  name: "Studio 101 Cut Out Dress in Black",
  brandToken: "b_ctgklsnnmx",
  brandName: "KkCo",
  imageUrl:
    "https://cdn.faire.com/fastly/056c91fc35c80da5b6630e68499936d8313fd5fc880ddd695160a5c26e6314d7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5571f4abcbba8748a28596a51e426097c953ea306f0adbd6dcecc4781c912f35.jpeg",
    "https://cdn.faire.com/fastly/b48331e962ebcc0af684cbef155e1fc30469a576442d8ee0aec7544f41c3b994.jpeg",
    "https://cdn.faire.com/fastly/0537826183f5146723d62cc1764b3c14d338b4c1122d2f0bd08d4daa5a46d62a.jpeg",
    "https://cdn.faire.com/fastly/5cd9f7682040e9de318b8cb5a140b1420922f4e04596257b404c798142efa36b.jpeg",
    "https://cdn.faire.com/fastly/b95ca9cbacc04ad12fb096739b1ecd59204fadcffa28680a0501f019ea488ae4.jpeg",
  ],
  priceDollars: 112.5,
  description:
    'Friends of KkCo: Studio\n\nStudio is a new underground project launched by an anonymous group of artists looking to create something together by exploring the art of making clothing. Studio was formed to be a community-driven creative outlet but has taken shape as a brand. New to the world and ever evolving, we\'re excited to be the first to introduce and offer Studio, exclusively at KkCo.\n\n\n\n * Floral Brocade fabric \n * Side cut out detail \n * Gathering detailing below cut outs for an accentuated waist fit \n * Sleeveless mid length dress \n * Invisible zipper back \n Size & Fit\n\n * Model is 5\'8" and wears size small \n * Fits true to size \nSize Guide\n\nSize Length (from highest shoulder point) Chest total \nS 50" 33" \nM 50.5" 35" \nL 51" 37" \n\n',
  tags: [],
  msrpDollars: 225,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:48.749Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
